
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "build": {
    "user": "root",
    "host": "f1ec5be16451",
    "time": "2025/05/02 06:57:56",
    "commit": "046dd80b6ab359300ecdacd40d0a920f2fffb7bb",
    "repo": "git@bitbucket.org:rscdevelopers/vv-public.git",
    "branch": "master",
    "release": "046dd80b6ab359300ecdacd40d0a920f2fffb7bb"
  },
  "nuxt": {}
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
